<template>
  <a-modal
    :visible="true"
    title="编辑报名表单字段"
    @ok="sub"
    @cancel="cancel"
  >
    <a-form
      :label-col="formItemLayout.labelCol"
      :wrapper-col="formItemLayout.wrapperCol"
    >
      <a-form-item label="字段标题">
        <a-input type="text" v-model="form.title"></a-input>
      </a-form-item>
      <a-form-item label="字段类型">
        <a-radio-group v-model="form.type">
          <a-radio
            v-for="(type, index) in typeList"
            :key="index"
            :value="type"
            @change="selectType"
            >{{ type }}</a-radio
          >
        </a-radio-group>
      </a-form-item>
      <a-form-item label="字段选项" v-if="showOptions">
        <div v-for="(item, index) in form.options" :key="index" class="flex-row">
          <a-input
            v-model="item.val"
            type="text"
            style="flex: 1;"
            placeholder="选项值"
          />

          <span v-if="['radio', 'select', 'checkbox'].includes(form.type)">人数</span>
          <a-input-number v-if="['radio', 'select', 'checkbox'].includes(form.type)" style="width: 70px" v-model="item.limit" />

          <span>费用</span>
          <a-input-number style="width: 70px" v-model="item.fee" />
          <a-button
            v-if="index == 0"
            shape="circle"
            icon="plus"
            style="margin-left: 10px"
            @click="addOption"
          ></a-button>
          <a-button
            v-else
            shape="circle"
            icon="minus"
            style="margin-left: 10px"
            @click="minusOption(index)"
          ></a-button>
        </div>
      </a-form-item>
      <a-form-item label="上传数量" v-if="form.type == 'upload'">
        <a-input-number v-model="form.upload_limit" :max="9" :min="1"></a-input-number>
      </a-form-item>
      <a-form-item label="默认值" v-if="this.form.type != 'upload'">
        <a-date-picker v-if="this.form.type == 'date'" v-model="form.default_val" />
        <a-date-picker v-else-if="this.form.type == 'datetime'" :showTime="{ defaultValue: moment('09:00:00', 'HH:mm:ss') }" v-model="form.default_val" />
        <a-time-picker v-else-if="this.form.type == 'time'" format="HH:mm" :minuteStep="10" v-model="form.default_val" />
        <a-input v-else v-model="form.default_val" style="width: 200px"></a-input>
      </a-form-item>
      <a-form-item label="提示语">
        <a-input v-model="form.tips"></a-input>
      </a-form-item>
      <a-form-item label="排序">
        <a-input-number v-model="form.order" style="width: 100px" />
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style lang="scss" scoped>
.flex-row{
  display: flex;
  align-items: center;
  span{
    margin-left: 10px;
    margin-right: 5px;
  }
}
</style>

<script>
import moment from "moment";

export default {
  props: ['oldData'],
  data() {
    return {
      formItemLayout: {
        labelCol: {
          span: 4,
        },
        wrapperCol: {
          span: 19,
        },
      },
      typeList: ["input", "radio", "checkbox", "select", "textarea", "upload", 'date', 'datetime', 'time'],
      form: {
        id: null,
        activity_id: 0,
        title: "",
        type: "input",
        upload_limit: 1,
        options: [{ val: "", fee: 0 }],
        order: 0,
        tips: "",
        default_val: ''
      },
    };
  },
  computed: {
    showOptions() {
      let show = ["radio", "checkbox", "select"].includes(this.form.type);
      if (!show) this.form.options = [{ val: "", fee: 0 }];
      return show;
    },
  },
  created() {
    const oldData = { ...this.oldData }
    if(oldData.type == 'date' || oldData.type == 'datetime'){
      oldData.default_val = moment(oldData.default_val)
    }
    else if(oldData.type == 'time'){
      oldData.default_val = moment().format('YYYY-MM-DD') + ' ' + oldData.default_val;
      oldData.default_val = moment(oldData.default_val)
    }
    this.form = oldData;
  },
  methods: {
    moment,
    selectType () {
      if(this.form.type == 'upload') this.form.default_val = '';
      else if (['date', 'datetime', 'time'].includes(this.form.type)) this.form.default_val = null;
    },
    addOption() {
      this.form.options.push({ val: "", fee: 0 });
    },
    minusOption(index) {
      this.form.options.splice(index, 1);
    },
    async sub() {
      const that = this;
      const r = await that.$axios.post("/activity/form/update", this.form);

      if (r.status == 1) {
        this.callback(true);
      }
    },

    cancel() {
      this.callback(false);
    },

    callback(e) {
      this.$emit("callback", e);
    },
  },
};
</script>